let plans = {
    "CBO-STD-TV": {
        apiCode: "CBO-STD-TV",
        startPlan: "basic",
        des: "Standard Combo",
        info: "",
        desFr: "Combo Standard",
        infoFr: "",
        isNet: true,
        isTv: true,
        isVoice: false,
    },
    "TRIO-STD": {
        apiCode: "TRIO-STD",
        startPlan: "basic",
        des: "Standard Trio",
        info: "",
        desFr: "Trio Standard",
        infoFr: "",
        isNet: true,
        isTv: true,
        isVoice: true,
    },
    "TV-ULT": {
        apiCode: "TV-ULT",
        startPlan: "advanced",
        des: "Ultimate TV",
        info: "",
        desFr: "Télévision Ultime",
        infoFr: "",
        isNet: true,
        isTv: true,
        isVoice: false,
    },
    "CBO-ULT-TV": {
        apiCode: "CBO-ULT-TV",
        startPlan: "advanced",
        des: "Ultimate Combo",
        info: "",
        desFr: "Combo Ultime",
        infoFr: "",
        isNet: true,
        isTv: true,
        isVoice: false,
    },
    "TRIO-ULT": {
        apiCode: "TRIO-ULT",
        startPlan: "advanced",
        des: "Ultimate Trio",
        info: "",
        desFr: "Trio Ultime",
        infoFr: "",
        isNet: true,
        isTv: true,
        isVoice: true,
    }
};

export default plans;